// src/utils/moneyAR.js
export const onlyDigits = (s) => String(s ?? "").replace(/\D/g, "");

export const formatARS = (rawDigits, { withSymbol = true } = {}) => {
  const digits = onlyDigits(rawDigits);
  if (!digits) return "";
  // agrupa de a 3 desde la derecha, usando '.' (AR)
  const parts = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return withSymbol ? `$${parts}` : parts;
};

// Para bloquear teclas no numéricas en inputs "solo números"
export const allowNumericKeys = (ev) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End",
    "Tab",
    "Enter",
  ];
  if (allowedKeys.includes(ev.key)) return; // permitir navegación
  if (/^\d$/.test(ev.key)) return; // permitir 0..9
  // Bloquear el resto (incluye '.' manual: lo formateamos nosotros)
  ev.preventDefault();
};

// Normaliza cualquier string formateado a entero JS (sin puntos/símbolos)
export const parseARSInt = (raw) => {
  const d = onlyDigits(raw);
  return d ? Number(d) : 0;
};

// Sanea un posible valor (string con $ y puntos, o number) a entero para payload
export const sanitizeMoneyPayload = (val) => {
  if (val === null || val === undefined || val === "") return 0;
  if (typeof val === "number") return val;
  return parseARSInt(String(val));
};

// Handy: para onChange de TextField (mantener en state solo dígitos)
export const handleMoneyInputValue = (ev, setValue) => {
  const digits = onlyDigits(ev.target.value);
  setValue(digits);
};

// Handy: para onPaste en TextField (pegar y sanear)
export const handleMoneyPaste = (ev, setValue) => {
  const text = (ev.clipboardData || window.clipboardData).getData("text");
  const digits = onlyDigits(text);
  if (!digits) return;
  ev.preventDefault();
  setValue(digits);
};